// extracted by mini-css-extract-plugin
module.exports =  {"content__media":"da51a739f7--content__media--K4bc4","content__description":"da51a739f7--content__description--tatfz"};